import { Navbar } from "flowbite-react";
import Cookies from "js-cookie";
import React from "react";
import { Link } from "react-router-dom";

const Navbars = () => {
  return (
    <React.Fragment>
      <Navbar fluid={true} rounded={true}>
        <Navbar.Brand>
          {/* <img
            src="https://flowbite.com/docs/images/logo.svg"
            className="mr-3 h-6 sm:h-9"
            alt="Flowbite Logo"
          /> */}
          <span className="p-2 bg-cyan-500 text-white rounded-lg self-center whitespace-nowrap text-xl font-semibold dark:text-white">
            YPU
          </span>
        </Navbar.Brand>
        <div className="flex md:order-2">
          <Navbar.Toggle />
          {!Cookies.get("token") && (
            <>
              <Link to={"/register"}>
                <button
                  type="button"
                  className="ml-2 text-white bg-cyan-500 hover:bg-cyan-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                >
                  Register
                </button>
              </Link>
              <Link to={"/login"}>
                <button
                  type="button"
                  className="ml-2 text-white bg-cyan-500 hover:bg-cyan-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                >
                  Login
                </button>
              </Link>
            </>
          )}
          {Cookies.get("token") && (
            <Link to={"/dashboard"}>
              <button
                type="button"
                className="ml-2 text-white bg-cyan-500 hover:bg-cyan-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              >
                Dashboard
              </button>
            </Link>
          )}
        </div>
        <Navbar.Collapse>
          <Link className="text-cyan-500" to="/">
            Beranda
          </Link>
          <Link className="text-cyan-500" to="/job-vacancy">
            Lowongan
          </Link>
        </Navbar.Collapse>
      </Navbar>
    </React.Fragment>
  );
};

export default Navbars;
